import React, {
    useEffect,
    useMemo,
    useState,
  } from "react";
  
  import {
    useLocation,
    useNavigate,
  } from "react-router-dom";
  
  import { db } from "../firebase";
  
  import {
    collection,
    addDoc,
    serverTimestamp,
  } from "firebase/firestore";
  
  import "./BfcConfirmDeposit.css";
  
  
  export default function ConfirmDeposit() {
    const navigate = useNavigate();
  
    const { state } = useLocation();
  
  
    /* =========================================================
       SUPPORT TANZANIA + OTHER COUNTRIES
    ========================================================= */
  
    const depositData =
      state?.deposit ||
      state ||
      {};
  
  
    /* =========================================================
       PROVIDER
    ========================================================= */
  
    const provider =
      depositData?.provider ||
      depositData?.paymentMethod ||
      "";
  
  
    /* =========================================================
       RECEIVING NUMBER
    ========================================================= */
  
    const number =
      depositData?.number ||
      depositData?.receivingNumber ||
      depositData?.businessNumber ||
      "";
  
  
    /* =========================================================
       RECEIVING NAME
    ========================================================= */
  
    const fullname =
      depositData?.fullname ||
      depositData?.receivingName ||
      depositData?.recipient ||
      "";
  
  
    /* =========================================================
       COUNTRY
    ========================================================= */
  
    const country =
      depositData?.countryName ||
      (
        typeof depositData?.country === "object"
          ? depositData?.country?.name
          : depositData?.country
      ) ||
      "Tanzania";
  
  
    /* =========================================================
       FLAG
    ========================================================= */
  
    const flag =
      depositData?.flag ||
      (
        typeof depositData?.country === "object"
          ? depositData?.country?.flag
          : ""
      ) ||
      (
        String(country).trim().toLowerCase() === "tanzania"
          ? "🇹🇿"
          : ""
      );
  
  
    /* =========================================================
       CURRENCY
       
       TANZANIA = TZS
    ========================================================= */
  
    const currency =
      depositData?.currency ||
      (
        typeof depositData?.country === "object"
          ? depositData?.country?.currency
          : ""
      ) ||
      (
        String(country)
          .trim()
          .toLowerCase() === "tanzania"
          ? "TZS"
          : "USD"
      );
  
  
    /* =========================================================
       DEPOSIT AMOUNT
    ========================================================= */
  
    const amount =
      Number(
        depositData?.amount ??
        depositData?.depositAmount ??
        0
      );
  
  
    /* =========================================================
       MINIMUM AMOUNT
    ========================================================= */
  
    const minimumAmount =
      Number(
        depositData?.minimumAmount ??
        0
      );
  
  
    /* =========================================================
       TANZANIA FIXED RATE
       
       1 USDT = 2,660 TZS
    ========================================================= */
  
    const isTanzania =
      String(country)
        .trim()
        .toLowerCase() === "tanzania";
  
  
    const TANZANIA_USDT_RATE = 2660;
  
  
    /* =========================================================
       EXCHANGE RATE
       
       Tanzania:
         ALWAYS 2660
       
       Other countries:
         Read from state
    ========================================================= */
  
    const exchangeRate =
      isTanzania
        ? TANZANIA_USDT_RATE
        : Number(
            depositData?.exchangeRate ??
            depositData?.rate ??
            0
          );
  
  
    /* =========================================================
       USDT RECEIVE AMOUNT
       
       Tanzania:
         TZS amount / 2660
       
       Other countries:
         Use sent usdtAmount/receiveAmount first,
         otherwise calculate from rate.
    ========================================================= */
  
    const usdtAmount = useMemo(() => {
  
      /* =======================================================
         TANZANIA
         1 USDT = 2,660 TZS
      ======================================================= */
  
      if (isTanzania) {
  
        if (
          amount > 0 &&
          TANZANIA_USDT_RATE > 0
        ) {
  
          return Number(
            (
              amount /
              TANZANIA_USDT_RATE
            ).toFixed(2)
          );
  
        }
  
        return 0;
      }
  
  
      /* =======================================================
         OTHER COUNTRIES
      ======================================================= */
  
      const sentUsdt =
        Number(
          depositData?.usdtAmount ??
          depositData?.receiveAmount ??
          0
        );
  
  
      if (sentUsdt > 0) {
  
        return Number(
          sentUsdt.toFixed(2)
        );
  
      }
  
  
      if (
        amount > 0 &&
        exchangeRate > 0
      ) {
  
        return Number(
          (
            amount /
            exchangeRate
          ).toFixed(2)
        );
  
      }
  
  
      return 0;
  
    }, [
      isTanzania,
      amount,
      depositData?.usdtAmount,
      depositData?.receiveAmount,
      exchangeRate,
    ]);
  
  
    /* =========================================================
       RECEIVE CURRENCY
    ========================================================= */
  
    const receiveCurrency =
      depositData?.receiveCurrency ||
      "USDT";
  
  
    /* =========================================================
       DEPOSIT METHOD
    ========================================================= */
  
    const depositMethod =
      depositData?.depositMethod ||
      "mobile";
  
  
    /* =========================================================
       ACCOUNT TYPE
    ========================================================= */
  
    const accountType =
      depositData?.accountType ||
      depositData?.paymentAccountType ||
      "";
  
  
    /* =========================================================
       USERNAME
    ========================================================= */
  
    const [
      username,
      setUsername,
    ] = useState("");
  
  
    /* =========================================================
       PHONE
    ========================================================= */
  
    const [
      phone,
      setPhone,
    ] = useState("");
  
  
    /* =========================================================
       TRANSACTION ID
    ========================================================= */
  
    const [
      transactionId,
      setTransactionId,
    ] = useState("");
  
  
    /* =========================================================
       LOADING
    ========================================================= */
  
    const [
      loading,
      setLoading,
    ] = useState(false);
  
  
    /* =========================================================
       GET USERNAME
    ========================================================= */
  
    useEffect(() => {
  
      const savedUsername =
        localStorage.getItem(
          "username"
        );
  
  
      if (savedUsername) {
  
        setUsername(
          savedUsername
        );
  
      }
  
    }, []);
  
  
    /* =========================================================
       DISPLAY VALUES
    ========================================================= */
  
    const finalRate =
      Number(
        exchangeRate || 0
      );
  
  
    const finalUsdtAmount =
      Number(
        usdtAmount || 0
      );
  
  
    /* =========================================================
       FORMAT DEPOSIT AMOUNT
    ========================================================= */
  
    const formatDepositAmount = (
      value
    ) => {
  
      const numeric =
        Number(value || 0);
  
  
      if (
        Number.isInteger(
          numeric
        )
      ) {
  
        return numeric.toLocaleString(
          "en-US"
        );
  
      }
  
  
      return numeric.toLocaleString(
        "en-US",
        {
          maximumFractionDigits: 2,
        }
      );
  
    };
  
  
    /* =========================================================
       FORMAT RATE
    ========================================================= */
  
    const formatRate = (
      value
    ) => {
  
      const numeric =
        Number(value || 0);
  
  
      if (
        numeric <= 0
      ) {
  
        return "-";
  
      }
  
  
      return numeric.toLocaleString(
        "en-US",
        {
          maximumFractionDigits: 4,
        }
      );
  
    };
  
  
    /* =========================================================
       CONFIRM DEPOSIT
    ========================================================= */
  
    const handleConfirm =
      async () => {
  
      /* =======================================================
         PHONE
      ======================================================= */
  
      if (
        !phone.trim()
      ) {
  
        alert(
          "Please enter your phone number."
        );
  
        return;
      }
  
  
      /* =======================================================
         TRANSACTION ID
      ======================================================= */
  
      if (
        !transactionId.trim()
      ) {
  
        alert(
          "Please enter the Transaction ID / Message."
        );
  
        return;
      }
  
  
      /* =======================================================
         USERNAME
      ======================================================= */
  
      if (!username) {
  
        alert(
          "Username not found. Please login again."
        );
  
        return;
      }
  
  
      /* =======================================================
         AMOUNT
      ======================================================= */
  
      if (
        !amount ||
        amount <= 0
      ) {
  
        console.error(
          "Invalid deposit amount. Deposit data:",
          depositData
        );
  
        alert(
          "Invalid deposit amount."
        );
  
        return;
      }
  
  
      /* =======================================================
         PROVIDER
      ======================================================= */
  
      if (!provider) {
  
        alert(
          "Payment provider not found."
        );
  
        return;
      }
  
  
      /* =======================================================
         RECEIVING NUMBER
      ======================================================= */
  
      if (!number) {
  
        alert(
          "Receiving account number not found."
        );
  
        return;
      }
  
  
      /* =======================================================
         TANZANIA RATE VALIDATION
         
         Tanzania MUST always be 2660.
      ======================================================= */
  
      if (
        isTanzania &&
        finalRate !== TANZANIA_USDT_RATE
      ) {
  
        console.error(
          "Invalid Tanzania exchange rate:",
          finalRate
        );
  
        alert(
          "Tanzania exchange rate must be 1 USDT = 2,660 TZS."
        );
  
        return;
      }
  
  
      /* =======================================================
         USDT VALIDATION
      ======================================================= */
  
      if (
        finalUsdtAmount <= 0
      ) {
  
        console.error(
          "Invalid USDT amount:",
          {
            amount,
            exchangeRate: finalRate,
            country,
            depositData,
          }
        );
  
        alert(
          "Invalid USDT receive amount."
        );
  
        return;
      }
  
  
      try {
  
        setLoading(true);
  
  
        /* =====================================================
           SAVE TO FIREBASE
           
           COLLECTION:
           volatilityotherbalance
        ===================================================== */
  
        await addDoc(
          collection(
            db,
            "volatilityotherbalance"
          ),
          {
  
            /* ===============================================
               USER
            =============================================== */
  
            username:
              username,
  
  
            /* ===============================================
               TRANSACTION
            =============================================== */
  
            type:
              "deposit",
  
            status:
              "processing",
  
  
            /* ===============================================
               PAYMENT METHOD
            =============================================== */
  
            method:
              provider,
  
            paymentMethod:
              provider,
  
            provider:
              provider,
  
  
            /* ===============================================
               RECEIVER
            =============================================== */
  
            businessNumber:
              number,
  
            receivingNumber:
              number,
  
            recipient:
              fullname,
  
            receivingName:
              fullname,
  
  
            /* ===============================================
               SENDER
            =============================================== */
  
            phone:
              phone.trim(),
  
            customerPhone:
              phone.trim(),
  
  
            /* ===============================================
               TRANSACTION ID
            =============================================== */
  
            transactionId:
              transactionId.trim(),
  
  
            /* ===============================================
               ORIGINAL DEPOSIT
            =============================================== */
  
            amount:
              Number(amount),
  
            depositAmount:
              Number(amount),
  
            currency:
              currency,
  
            depositCurrency:
              currency,
  
  
            /* ===============================================
               COUNTRY
            =============================================== */
  
            country:
              country,
  
            countryName:
              country,
  
            flag:
              flag,
  
  
            /* ===============================================
               EXCHANGE RATE
               
               TANZANIA = 2660
            =============================================== */
  
            rate:
              finalRate,
  
            exchangeRate:
              finalRate,
  
  
            /* ===============================================
               USDT
               
               IMPORTANT:
               This is the calculated amount.
            =============================================== */
  
            usdtAmount:
              finalUsdtAmount,
  
            receiveAmount:
              finalUsdtAmount,
  
            receiveCurrency:
              receiveCurrency,
  
  
            /* ===============================================
               DEPOSIT METHOD
            =============================================== */
  
            depositMethod:
              depositMethod,
  
            walletType:
              "mobile_money",
  
  
            /* ===============================================
               ACCOUNT TYPE
            =============================================== */
  
            accountType:
              accountType,
  
            paymentAccountType:
              accountType,
  
  
            /* ===============================================
               MINIMUM AMOUNT
            =============================================== */
  
            minimumAmount:
              minimumAmount,
  
  
            /* ===============================================
               VERIFICATION
            =============================================== */
  
            excludeVerification:
              depositData?.excludeVerification ||
              false,
  
  
            /* ===============================================
               TIMESTAMPS
            =============================================== */
  
            createdAt:
              serverTimestamp(),
  
            updatedAt:
              serverTimestamp(),
  
          }
        );
  
  
        /* =====================================================
           SUCCESS MESSAGE
        ===================================================== */
  
        alert(
          `Deposit submitted successfully.\n\n` +
          `${currency} ${formatDepositAmount(
            amount
          )}` +
          ` ≈ ${finalUsdtAmount.toFixed(
            2
          )} USDT`
        );
  
  
        /* =====================================================
           DASHBOARD
        ===================================================== */
  
        navigate(
          "/dashboard"
        );
  
  
      } catch (error) {
  
        console.error(
          "Deposit submission error:",
          error
        );
  
  
        alert(
          "Failed to submit deposit. Please try again."
        );
  
  
      } finally {
  
        setLoading(false);
  
      }
  
    };
  
  
    /* =========================================================
       RENDER
    ========================================================= */
  
    return (
  
      <div className="deposit-confirm-page">
  
  
        {/* =====================================================
            HEADER
        ===================================================== */}
  
        <div className="deposit-header">
  
          <button
            className="back-button"
            onClick={() =>
              navigate(-1)
            }
            type="button"
          >
            🔙
          </button>
  
  
          <h2>
            Deposit Confirmation
          </h2>
  
        </div>
  
  
        {/* =====================================================
            PAYMENT SUMMARY
        ===================================================== */}
  
        <div className="deposit-summary">
  
          <div className="success-icon">
            ✅
          </div>
  
  
          <h3>
            Payment Summary
          </h3>
  
  
          {/* ===================================================
              COUNTRY
          =================================================== */}
  
          <div className="summary-row">
  
            <span>
              Country
            </span>
  
  
            <b>
              {flag} {country}
            </b>
  
          </div>
  
  
          {/* ===================================================
              AMOUNT
          =================================================== */}
  
          <div className="summary-row">
  
            <span>
              Amount
            </span>
  
  
            <b>
              {currency}{" "}
              {formatDepositAmount(
                amount
              )}
            </b>
  
          </div>
  
  
          {/* ===================================================
              EXCHANGE RATE
          =================================================== */}
  
          <div className="summary-row">
  
            <span>
              Exchange Rate
            </span>
  
  
            <b>
  
              {finalRate > 0
                ? (
                  <>
                    1 USDT ={" "}
                    {formatRate(
                      finalRate
                    )}{" "}
                    {currency}
                  </>
                )
                : "-"
              }
  
            </b>
  
          </div>
  
  
          {/* ===================================================
              RECEIVE
          =================================================== */}
  
          <div className="summary-row">
  
            <span>
              You Receive
            </span>
  
  
            <b>
              {finalUsdtAmount.toFixed(
                2
              )}{" "}
              {receiveCurrency}
            </b>
  
          </div>
  
  
          {/* ===================================================
              PROVIDER
          =================================================== */}
  
          <div className="summary-row">
  
            <span>
              Provider
            </span>
  
  
            <b>
              {provider || "-"}
            </b>
  
          </div>
  
  
          {/* ===================================================
              RECIPIENT
          =================================================== */}
  
          <div className="summary-row">
  
            <span>
              Recipient
            </span>
  
  
            <b>
              {fullname || "-"}
            </b>
  
          </div>
  
  
          {/* ===================================================
              ACCOUNT NUMBER
          =================================================== */}
  
          <div className="summary-row">
  
            <span>
              Account Number
            </span>
  
  
            <b>
              {number || "-"}
            </b>
  
          </div>
  
        </div>
  
  
        {/* =====================================================
            FORM
        ===================================================== */}
  
        <div className="deposit-form">
  
  
          {/* USERNAME */}
  
          <label>
            Username
          </label>
  
  
          <input
            type="text"
            value={username}
            readOnly
            className="readonly-input"
          />
  
  
          {/* PHONE */}
  
          <label>
            Sender Phone Number /
            Enter Your Number
          </label>
  
  
          <input
            type="tel"
            placeholder="07XXXXXXXX"
            value={phone}
            onChange={(e) =>
              setPhone(
                e.target.value
              )
            }
          />
  
  
          {/* TRANSACTION ID */}
  
          <label>
            Transaction ID / Message
          </label>
  
  
          <input
            type="text"
            placeholder="Example: DH23NXXXX..."
            value={transactionId}
            onChange={(e) =>
              setTransactionId(
                e.target.value
              )
            }
          />
  
  
          {/* WARNING */}
  
          <div className="deposit-warning">
  
            Please confirm that you have
            already completed the payment
            before submitting this form.
  
          </div>
  
  
          {/* SUBMIT */}
  
          <button
            className="submit-deposit-btn"
            onClick={
              handleConfirm
            }
            disabled={loading}
            type="button"
          >
  
            {loading
              ? "Submitting..."
              : "Confirm Deposit / I Have Paid"}
  
          </button>
  
        </div>
  
      </div>
  
    );
  }